import a from './axios'
import config from './../config'
const token = localStorage.getItem('token')
a.defaults.headers.common = { Authorization: `Bearer ${token}` }
const headers = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*'
}

const prefixEndpoint = config.apiBaseUrl

export default {
  getToken() {
    const token = localStorage.getItem('token')
    a.defaults.headers.common = { Authorization: `Bearer ${token}` }
  },
  async getWarehousesList() {
    return await a.get(prefixEndpoint + 'warehouse/list', headers)
  },
  addWarehouse(payload) {
    return a.post(prefixEndpoint + 'warehouse/create', payload, headers)
  },
  getWarehouse(payload) {
    return a.post(prefixEndpoint + 'warehouse/read', payload, headers)
  },
  updateWarehouse(payload) {
    return a.post(prefixEndpoint + 'warehouse/update', payload, headers)
  },
  deleteWarehouse(payload) {
    return a.post(prefixEndpoint + 'warehouse/delete', payload, headers)
  },
  getWarehouseIntegration(payload) {
    return a.post(`${prefixEndpoint}warehouse/integration/read`, payload, headers)
  },
  getWarehouseMap(payload) {
    return a.post(prefixEndpoint + 'warehouse/map', payload, headers)
  },
  createWarehouseRack(payload) {
    return a.post(prefixEndpoint + 'warehouse/rack/create', payload, headers)
  },
  updateWarehouseRack(payload) {
    return a.post(prefixEndpoint + 'warehouse/rack/update', payload, headers)
  },
  deleteWarehouseRack(payload) {
    return a.post(prefixEndpoint + 'warehouse/rack/delete', payload, headers)
  },
  createWarehouseRackShelf(payload) {
    return a.post(prefixEndpoint + 'warehouse/rack/shelf/create', payload, headers)
  },
  updateWarehouseRackShelf(payload) {
    return a.post(prefixEndpoint + 'warehouse/rack/shelf/update', payload, headers)
  },
  deleteWarehouseRackShelf(payload) {
    return a.post(prefixEndpoint + 'warehouse/rack/shelf/delete', payload, headers)
  },
  createWarehouseRackShelfBin(payload) {
    return a.post(prefixEndpoint + 'warehouse/rack/shelf/bin/create', payload, headers)
  },
  updateWarehouseRackShelfBin(payload) {
    return a.post(prefixEndpoint + 'warehouse/rack/shelf/bin/update', payload, headers)
  },
  deleteWarehouseRackShelfBin(payload) {
    return a.post(prefixEndpoint + 'warehouse/rack/shelf/bin/delete', payload, headers)
  },
  getWarehouseRackShelfBin(payload) {
    return a.post(prefixEndpoint + 'warehouse/rack/shelf/bin/read', payload, headers)
  },
  getWarehouseMapBarcodesPdf(payload) {
    return a.post(
      prefixEndpoint + 'warehouse/map/barcodes/pdf',
      payload, {
        headers: headers,
        responseType: 'blob'
      }).then(res => { return res })
  },
  getWarehouseMapItemBarcodePdf(payload) {
    return a.post(
      prefixEndpoint + 'warehouse/map/item/barcode/pdf',
      payload, {
        headers: headers,
        responseType: 'blob'
      }).then(res => { return res })
  }
}
